const metaValue = name => {
  const tag = document.querySelector(`meta[name='${name}']`);

  return tag ? tag.content : '';
};

export default metaValue;
